import css from 'styled-jsx/css';
import { common } from '../../theme/theme';

const style = css`
  .sharepoint-wizard :global(.submit-button) {
    ${common.button}
    ${common.submitButton}
    margin-top: 30px;
  }
  .sharepoint-wizard :global(.submit-button:hover) {
    ${common.button}
    ${common.submitButton}
    margin-top: 30px;
  }
  .sharepoint-wizard :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .sharepoint-wizard :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
  .sharepoint-wizard :global(.list-item-wrapper) {
    margin: 0 0 16px;
    text-align: left;
  }
  .sharepoint-wizard :global(.ant-input-search-button) {
    ${common.submitButton}
    border-radius: 0 8px 8px 0 !important;
  }
  .sharepoint-wizard :global(.ant-input-search-button:hover) {
    ${common.submitButton}
    border-radius: 0 8px 8px 0 !important;
  }
  .sharepoint-wizard :global(.upload-type-row) {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
  }
  .sharepoint-wizard :global(.upload-type-label) {
    margin-right: 12px;
    white-space: nowrap;
  }
`;

export default style;
